import * as z from "zod";

export const createWorkOrder = {
  name: "createWorkOrder" as const,
  input: z.object({
    flowId: z.string(),
    bomId: z.string(),
    locationId: z.string(),
    quantity: z.number().int().positive(),
  }),
  output: z.object({ workOrderId: z.string() }),
};
